import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-66940990")
const _hoisted_1 = { class: "operation-trail-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("内容")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("˝ ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "视频", -1)
const _hoisted_5 = {
  key: 0,
  class: "video-list"
}
const _hoisted_6 = ["src", "poster"]
const _hoisted_7 = { class: "bottom-btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: _ctx.content,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.content = $event)),
          rows: 4,
          name: "content",
          type: "textarea",
          placeholder: "请输入",
          rules: [{ required: true, message: '请输入内容' }]
        }, {
          label: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          name: "images",
          border: false,
          label: "照片"
        }, {
          input: _withCtx(() => [
            _createVNode(_component_stcp_h5_uploader, {
              modelValue: _ctx.imageList,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.imageList = $event)),
              multiple: "",
              "after-read": _ctx.imageUploadAfter,
              onDelete: _ctx.delBefore,
              onPoster: _ctx.onClickImgPoster,
              "max-count": 9
            }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_field, {
          name: "videos",
          border: false
        }, {
          label: _withCtx(() => [
            _hoisted_4
          ]),
          input: _withCtx(() => [
            _createVNode(_component_stcp_h5_uploader, {
              modelValue: _ctx.videoList,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.videoList = $event)),
              "after-read": _ctx.afterUploadVideo,
              "before-read": _ctx.onBeforeUpload,
              accept: "video/*",
              onDelete: _ctx.onDeleteVideo,
              onPoster: _ctx.onClickVideo,
              "max-count": 1
            }, null, 8, ["modelValue", "after-read", "before-read", "onDelete", "onPoster"])
          ]),
          _: 1
        }),
        (_ctx.uploadSuccessVideoList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadSuccessVideoList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "v-pos",
                  key: index
                }, [
                  _createElementVNode("video", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showVideos = true)),
                    src: item,
                    width: "80",
                    height: "80",
                    poster: item + '?vframe/jpg/offset/1/w/88/h/88'
                  }, null, 8, _hoisted_6),
                  _createVNode(_component_van_icon, {
                    class: "del",
                    onClick: ($event: any) => (_ctx.delVideoBefore(index)),
                    name: "close"
                  }, null, 8, ["onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            style: {"border-radius":"0.625rem"},
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_preview_video, {
      visible: _ctx.showVideos,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showVideos = $event)),
      url: _ctx.videoUrl,
      autoplay: ""
    }, null, 8, ["visible", "url"])
  ]))
}